export interface Publication {
  title: string;
  journal: string;
  authors: string;
  epub?: string;
  year?: string;
  volume?: string;
  pages?: string;
  doi?: string;
  url?: string; // Add URL for hyperlinking publications
}

export const publications: Publication[] = [
  {
    title: 'Single-dose psilocybin rapidly and sustainably relieves allodynia and anxiodepressive-like behaviors in mouse models of chronic pain.',
    journal: 'Nature Neuroscience',
    authors: 'Hammo A, Wisser S, Cichon J',
    epub: '2025 Nov;28(11):2285-2295 Epub 2025 Oct 2',
    year: '2025',
    url: 'https://pubmed.ncbi.nlm.nih.gov/41039182/',
  },
  {
    title: 'Nitrous oxide activates layer 5 prefrontal neurons via SK2 channel inhibition for antidepressant effect.',
    journal: 'Nature Communications',
    authors: 'Cichon J, Joseph TT, Lu X, Wasilczuk AZ, Kelz MB, Mennerick SJ, Zorumski CF, Nagele P',
    epub: '2025 Apr 3;16(1):2999',
    year: '2025',
    url: 'https://pubmed.ncbi.nlm.nih.gov/40180931/',
  },
  {
    title: 'General Anesthesia Occludes Ketamine\'s Antidepressant Response in a Rodent Model of Chronic Stress.',
    journal: 'Psychedelic Medicine (New Rochelle, N.Y.)',
    authors: 'Markman D, Wasilczuk AZ, Cichon JM',
    epub: '2024 Dec;2(4):192-200 Epub 2024 Dec 2',
    year: '2024',
    url: 'https://pubmed.ncbi.nlm.nih.gov/39720814/',
  },
  {
    title: 'Nitrous Oxide activates layer 5 prefrontal neurons via SK2 channel inhibition for antidepressant effect.',
    journal: 'Research Square',
    authors: 'Cichon J, Joseph TT, Lu X, Wasilczuk AZ, Kelz MB, Mennerick SJ, Zorumski CF, Nagele P',
    epub: '2024 Nov 15',
    year: '2024',
    url: 'https://pubmed.ncbi.nlm.nih.gov/39606485/',
  },
  {
    title: 'Ketamine triggers a switch in excitatory neuronal activity across neocortex.',
    journal: 'Nature Neuroscience',
    authors: 'Cichon J, Wasilczuk AZ, Looger LL, Contreras D, Kelz MB, Proekt A',
    epub: '2023 Jan;26(1):39-52 Epub 2022 Nov 24',
    year: '2023',
    url: 'https://pubmed.ncbi.nlm.nih.gov/36424433/',
  },
  {
    title: 'Therapeutic Potential of Salvinorin A and Its Analogues in Various Neurological Disorders.',
    journal: 'Translational Perioperative and Pain Medicine',
    authors: 'Cichon J, Liu R, Le HV',
    epub: '2022;9(2):452-457 Epub 2022 Jun 29',
    year: '2022',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9364973/',
  },
  {
    title: 'Experience and sleep-dependent synaptic plasticity: from structure to activity.',
    journal: 'Philosophical Transactions of the Royal Society of London. Series B, Biological Sciences',
    authors: 'Sun L, Zhou H, Cichon J, Yang G',
    epub: '2020 May 25;375(1799):20190234 Epub 2020 Apr 6',
    year: '2020',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC7209921/',
  },
  {
    title: 'Imaging neuronal activity in the central and peripheral nervous systems using new Thy1.2-GCaMP6 transgenic mouse lines.',
    journal: 'Journal of Neuroscience Methods',
    authors: 'Cichon J, Magrané J, Shtridler E, Chen C, Sun L, Yang G, Gan WB',
    epub: '2020 Mar 15;334:108535 Epub 2020 Jan 20',
    year: '2020',
    url: 'https://pubmed.ncbi.nlm.nih.gov/31972184/',
  },
  {
    title: 'Spared Nerve Injury Model of Neuropathic Pain in Mice.',
    journal: 'Bio-protocol',
    authors: 'Cichon J, Sun L, Yang G',
    epub: '2018 Mar 20;8(6)',
    year: '2018',
    url: 'https://pubmed.ncbi.nlm.nih.gov/29682596/',
  },
  {
    title: 'Activation of cortical somatostatin interneurons prevents the development of neuropathic pain.',
    journal: 'Nature Neuroscience',
    authors: 'Cichon J, Blanck TJJ, Gan WB, Yang G',
    epub: '2017 Aug;20(8):1122-1132 Epub 2017 Jun 26',
    year: '2017',
    url: 'https://www.nature.com/articles/nn.4595',
  },
  {
    title: 'Post-anesthesia AMPA receptor potentiation prevents anesthesia-induced learning and synaptic deficits.',
    journal: 'Science Translational Medicine',
    authors: 'Huang L, Cichon J, Ninan I, Yang G',
    epub: '2016 Jun 22;8(344):344ra85',
    year: '2016',
    url: 'https://pubmed.ncbi.nlm.nih.gov/27334260/',
  },
  {
    title: 'Branch-specific dendritic Ca(2+) spikes cause persistent synaptic plasticity.',
    journal: 'Nature',
    authors: 'Cichon J, Gan WB',
    epub: '2015 Apr 9;520(7546):180-5 Epub 2015 Mar 30',
    year: '2015',
    url: 'https://www.nature.com/articles/nature14251',
  },
  {
    title: 'Sleep promotes branch-specific formation of dendritic spines after learning.',
    journal: 'Science (New York, N.Y.)',
    authors: 'Yang G, Lai CS, Cichon J, Ma L, Li W, Gan WB',
    epub: '2014 Jun 6;344(6188):1173-8',
    year: '2014',
    url: 'https://pubmed.ncbi.nlm.nih.gov/24904169/',
  },
  {
    title: 'Circadian glucocorticoid oscillations promote learning-dependent synapse formation and maintenance.',
    journal: 'Nature Neuroscience',
    authors: 'Liston C, Cichon JM, Jeanneteau F, Jia Z, Chao MV, Gan WB',
    epub: '2013 Jun;16(6):698-705 Epub 2013 Apr 28',
    year: '2013',
    url: 'https://pubmed.ncbi.nlm.nih.gov/23624512/',
  },
  {
    title: 'Cofilin aggregation blocks intracellular trafficking and induces synaptic loss in hippocampal neurons.',
    journal: 'The Journal of Biological Chemistry',
    authors: 'Cichon J, Sun C, Chen B, Jiang M, Chen XA, Sun Y, Wang Y, Chen G',
    epub: '2012 Feb 3;287(6):3919-29 Epub 2011 Dec 19',
    year: '2012',
    url: 'https://pubmed.ncbi.nlm.nih.gov/22184127/',
  },
];

